import { render, staticRenderFns } from "./AamsRegSealAuthApproval.vue?vue&type=template&id=26e93a0d&scoped=true&"
import script from "./AamsRegSealAuthApproval.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealAuthApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e93a0d",
  null
  
)

export default component.exports